import React, { useState } from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import SecBTN from '../../UI/SecBTN';
import Input from '../../UI/Input/Input';
import Graybg from '../../UI/Graybg';
import userService from '../../app/services/user.service';

const UploadSolution = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = () => {
    // const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
    if (!file) {
      alert('Please select a file to upload');
      return;
    }

    setLoading(true);
    
    const formData = new FormData();
    formData.append('video_solution_file', file);
    

    userService.uploadVideoSolution(formData)
      .then(res => {
        console.log(res.data);
        alert('Solution file uploaded successfully');
        setLoading(false);
        setFile(null);
        // Reset file input
        document.getElementById('formFile').value = '';
      })
      .catch(err => {
        console.error(err);
        alert('Error uploading solution file');
        setLoading(false);
      });
  };

  const downloadFile = () => {
    console.log(window.location.origin);
    fetch(window.location.origin + "/files/New_DPP_Video_sol.xlsx").then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
             
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "new_DPP_Video_sol.xlsx";
        alink.click();
      });
    });
  };

  return (
    <div>
      <Graybg>
        <Row>
          <Col lg={6} md={6} sm={12} className='mb-3'>
            <h5 className='mb-3'>Upload Paper Request</h5>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload here:</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
            <SecBTN className='sec-btn1' onClick={handleUpload} disabled={loading}>
              {loading ? 'Uploading...' : 'Upload'}
            </SecBTN>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <SecBTN className='sec-btn1' onClick={downloadFile}>
              <i className="fa fa-download"></i> Sample File
            </SecBTN>
          </Col>
        </Row>
      </Graybg>
    </div>
  );
};

export default UploadSolution;